const Holder = require("holderjs");
Holder.addTheme("vue", { bg: "#4FC08D", fg: "#FFFFFF" });
Holder.addTheme("facebook", { bg: "#3b5998", fg: "#FFFFFF" });
Holder.addTheme("twitter", { bg: "#55acee", fg: "#FFFFFF" });
Holder.addTheme("youtube", { bg: "#bb0000", fg: "#FFFFFF" });
Holder.addTheme("tumblr", { bg: "#32506d", fg: "#FFFFFF" });
Holder.addTheme("github", { bg: "#000000", fg: "#FFFFFF" });
Holder.addTheme("whatsapp", { bg: "#4dc247", fg: "#FFFFFF" });

import {
  formatDateTime,
  formatDate,
  formatDateTimeUnix,
  formatDateUnix,
  today,
  dateRange,
  toMillisecondTimestamp
} from "../utils/date";
import * as store from "@/_store";
const STORE = store.store.getters;
const GlobalMethods = {
  install(Vue) {
    Vue.prototype.$imgHolder = function(event) {
      Holder.run({ images: event.target });
    };
    Vue.prototype.$dateTime = function(datetime) {
      return formatDateTime(datetime);
    };
    Vue.prototype.$toMillisecondTimestamp = function(datetime) {
      return toMillisecondTimestamp(datetime);
    };
    Vue.prototype.$dateTimeUnix = function(datetime) {
      return formatDateTimeUnix(datetime);
    };
    Vue.prototype.$date = function(datetime, format = "DD/MM/YYYY") {
      return formatDate(datetime, format);
    };
    Vue.prototype.$dateUnix = function(datetime) {
      return formatDateUnix(datetime);
    };
    Vue.prototype.$today = function(format = "DD/MM/YYYY") {
      return today(format);
    };

    Vue.prototype.$dateRange = function(startDate, endDate) {
      return dateRange(startDate, endDate);
    };

    Vue.prototype.$permission = function(feature) {
      const rules = STORE.rules;

      let per = false;
      if (STORE.role.id == 1) per = true;
      else if (!rules[feature]) per = false;
      else per = rules[feature];
      // console.log("checkPermission", feature, per);
      return per;
    };

    Vue.prototype.$formatNumber = function(n, log = false) {
      if (log) console.log(n);
      return new Intl.NumberFormat("en", {
        style: "decimal",
        maximumFractionDigits: 4
      }).format(n);
    };
    Vue.prototype.$formatNumberFixed = function(n, fix = 0) {
      return new Intl.NumberFormat("en", {
        style: "decimal",
        maximumFractionDigits: fix
      }).format(n);
    };
    Vue.prototype.$ucWord = function(str) {
      return str.toLowerCase().replace(/\b[a-z]/g, function(letter) {
        return letter.toUpperCase();
      });
    };

    Vue.prototype.$formatCurrency = function(n, log = false) {
      if (log) console.log(n);
      return new Intl.NumberFormat("en", {
        style: "decimal",
        maximumFractionDigits: 5
      }).format(n);
    };
  }
};
export default GlobalMethods;
